import { z } from 'zod';

export const formSchema = z.object({
  nombre: z.string().min(3, 'El nombre debe tener al menos 3 caracteres',),
  descripcion: z.string().optional(),
  reglas: z.string().optional(),
  hexFondo: z.string().regex(/^#[0-9A-Fa-f]{6}$/).optional(),
  hexTexto: z.string().regex(/^#[0-9A-Fa-f]{6}$/).optional(),
  sucursales: z.array(z.object({
    value: z.string(),
    label: z.string(),
  })).nonempty('Selecciona una sucursal'),
  imagen: z.string().optional(),
  fechaInicio: z.string().min(1, 'La fecha de inicio del torneo es obligatoria'),
  fechaFin: z.string().min(1, 'La fecha de fin del torneo es obligatoria'),
  fechaInicioInscripcion: z.string().min(1, 'La fecha de inicio de inscripción es obligatoria'),
  fechaFinInscripcion: z.string().min(1, 'La fecha de fin de inscripción es obligatoria'),
  tipoTorneo: z.enum(['individual', 'team']),
  genero: z.enum(['male', 'female', 'mixed', 'open']),
  formato: z.enum(['single_elimination', 'double_elimination', 'round_robin', 'groups_knockout']),
  aprobacion: z.enum(['automatic', 'manual']),
  maxJugadores: z.coerce.number().min(2, 'El límite de participantes debe ser al menos 2'),
  categoriaInicio: z.coerce.number().min(1, 'La categoría inicial es obligatoria').max(8),
  categoriaFin: z.preprocess(
    (val) => (val === "" || val === "0" || val === 0 || val === null || val === undefined ? undefined : Number(val)),
    z.number().min(1).max(8).optional()
  ),
  costo: z.coerce.number().min(0).optional(),
  instruccionesPago: z.string().optional(),
}).superRefine((data, ctx) => {
  console.log("data",data);
  if (data.fechaInicio && data.fechaFin && new Date(data.fechaFin) < new Date(data.fechaInicio)) {
    ctx.addIssue({
      path: ['fechaFin'],
      code: z.ZodIssueCode.custom,
      message: 'La fecha de fin debe ser posterior o igual a la de inicio',
    });
  }

  if (data.fechaInicioInscripcion && data.fechaFinInscripcion && new Date(data.fechaFinInscripcion) < new Date(data.fechaInicioInscripcion)) {
    ctx.addIssue({
      path: ['fechaFinInscripcion'],
      code: z.ZodIssueCode.custom,
      message: 'La fecha de fin de inscripción debe ser posterior o igual a la de inicio',
    });
  }

  if (data.fechaFinInscripcion && data.fechaInicio && new Date(data.fechaInicio) < new Date(data.fechaFinInscripcion)) {
    ctx.addIssue({
      path: ['fechaInicio'],
      code: z.ZodIssueCode.custom,
      message: 'El torneo debe iniciar después del cierre de inscripción',
    });
  }

  if (data.categoriaInicio && data.categoriaFin) {
    const diff = Math.abs(data.categoriaInicio - data.categoriaFin);
    if (diff > 1) {
      ctx.addIssue({
        path: ['categoriaFin'],
        code: z.ZodIssueCode.custom,
        message: 'Solo se pueden unir categorías contiguas (ej: 8 y 7, pero no 8 y 6)',
      });
    }
  }
});
